import { css } from '@emotion/react'
import {
  Color,
  Shadow,
  ShadowElevation,
  Size,
  Spacing,
  Typography,
  ZIndex,
} from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lambda'

export const container = (hasComments: boolean) =>
  css({
    borderRadius: Size.Rounding * 3,
    border: `1px solid ${Color.light['Strokes/Secondary-1']}`,
    padding: `${Spacing.S}px`,
    backgroundColor: Color.light['Color/Surface/Surface-1'],
    inlineSize: '360px',
    maxBlockSize: '465px',
    display: 'flex',
    flexDirection: 'column',
    position: hasComments ? 'absolute' : 'relative',
    boxShadow: Shadow[ShadowElevation.E2].boxShadow,
    zIndex: ZIndex.Shroud.Popover,
  })

export const threadHeader = css({
  ...Typography.T300,
  fontSize: '14px',
  color: Color.light['Text/Secondary'],
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBlockEnd: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  marginInline: Spacing.S,
  paddingBlockEnd: Spacing.S,
  flex: '0 0 auto',
})

export const headerActions = css({
  display: 'flex',
  gap: Spacing.S,
  alignItems: 'center',
})

export const headerButton = css({
  color: Color.light['Text/Secondary'],
})

export const optionMenu = css({
  minInlineSize: '250px',
  zIndex: ZIndex.Shroud.Popover,
})

export const optionMenuItem = css({
  display: 'flex',
  gap: Spacing.XS,
  alignItems: 'center',
})

export const content = css({
  flex: '0 1 100%',
  ...modernWithFallback(
    [{ overflowBlock: 'auto' }, { overflowY: 'auto' }],
    'overflow-block: auto'
  ),
  marginInline: Spacing.S,
})

export const footer = css({
  paddingBlockStart: Spacing.S,
  backgroundColor: Color.light['Color/Surface/Surface-1'],
  flex: '1 0 auto',
})

export const textAndActionsContainer = css({
  borderRadius: Size.Rounding * 3,
  border: `1px solid ${Color.light['Strokes/Secondary-1']}`,
  backgroundColor: Color.light['Color/Surface/Surface-2'],
  paddingInline: Spacing.S,
  paddingBlock: Spacing.S,

  '&:only-child': {
    borderRadius: Size.Rounding * 2,
  },

  '&:focus-within': {
    borderColor: Color.light['Strokes/Primary-2'],
    backgroundColor: Color.light['Color/Surface/Surface-1'],
  },
})

export const textInput = css({
  border: 'none',
  padding: 0,
  inlineSize: '100%',
  backgroundColor: 'transparent',

  scrollbarColor: 'transparent transparent',
  '::webkit-scrollbar': {
    display: 'none',
  },

  '&:active:enabled, &:focus:enabled': {
    border: `none`,
  },
})

export const footerActions = css({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingBlockStart: Spacing.S,
  opacity: 1,
  blockSize: '32px',
})
